// Generated by Melange

import * as Stdlib__String from "melange/string.js";

function workspace(param) {
  if (/* tag */ typeof param !== "object" && typeof param !== "function" || param.TAG === /* Invitation */ 0) {
    return;
  } else {
    return param._0;
  }
}

function project(param) {
  if (/* tag */ typeof param !== "object" && typeof param !== "function") {
    return;
  }
  switch (param.TAG) {
    case /* Project */ 2 :
    case /* Session */ 3 :
      return param._1;
    default:
      return;
  }
}

function session(param) {
  if (/* tag */ typeof param !== "object" && typeof param !== "function" || param.TAG !== /* Session */ 3) {
    return;
  } else {
    return param._2;
  }
}

function path(token) {
  if (/* tag */ typeof token !== "object" && typeof token !== "function") {
    return "/";
  }
  switch (token.TAG) {
    case /* Invitation */ 0 :
      return "/invite/" + token._0;
    case /* Workspace */ 1 :
      return "/w/" + token._0;
    case /* Project */ 2 :
      return "/w/" + (token._0 + ("/p/" + token._1));
    case /* Session */ 3 :
      return "/w/" + (token._0 + ("/p/" + (token._1 + ("/s/" + token._2))));
  }
}

function valid(value) {
  if (value !== "" && value.length <= 128) {
    return Stdlib__String.for_all((function (param) {
      if (param >= 65) {
        if (param > 96 || param < 91) {
          return param < 123;
        } else {
          return param === 95;
        }
      } else if (param >= 48) {
        return param < 58;
      } else {
        return param === 45;
      }
    }), value);
  } else {
    return false;
  }
}

function route(path) {
  const match = Stdlib__String.split_on_char(/* '/' */47, path);
  if (!match) {
    return /* Home */ 0;
  }
  if (match.hd !== "") {
    return /* Home */ 0;
  }
  const match$1 = match.tl;
  if (!match$1) {
    return /* Home */ 0;
  }
  switch (match$1.hd) {
    case "invite" :
      const match$2 = match$1.tl;
      if (!match$2) {
        return /* Home */ 0;
      }
      if (match$2.tl) {
        return /* Home */ 0;
      }
      const token = match$2.hd;
      if (token.length === 43 && valid(token)) {
        return {
          TAG: /* Invitation */ 0,
          _0: token
        };
      } else {
        return /* Home */ 0;
      }
    case "w" :
      const match$3 = match$1.tl;
      if (!match$3) {
        return /* Home */ 0;
      }
      const match$4 = match$3.tl;
      const w = match$3.hd;
      if (!match$4) {
        if (valid(w)) {
          return {
            TAG: /* Workspace */ 1,
            _0: w
          };
        } else {
          return /* Home */ 0;
        }
      }
      if (match$4.hd !== "p") {
        return /* Home */ 0;
      }
      const match$5 = match$4.tl;
      if (!match$5) {
        return /* Home */ 0;
      }
      const match$6 = match$5.tl;
      const p = match$5.hd;
      if (!match$6) {
        if (valid(w) && valid(p)) {
          return {
            TAG: /* Project */ 2,
            _0: w,
            _1: p
          };
        } else {
          return /* Home */ 0;
        }
      }
      if (match$6.hd !== "s") {
        return /* Home */ 0;
      }
      const match$7 = match$6.tl;
      if (!match$7) {
        return /* Home */ 0;
      }
      if (match$7.tl) {
        return /* Home */ 0;
      }
      const s = match$7.hd;
      if (valid(w) && valid(p) && valid(s)) {
        return {
          TAG: /* Session */ 3,
          _0: w,
          _1: p,
          _2: s
        };
      } else {
        return /* Home */ 0;
      }
    default:
      return /* Home */ 0;
  }
}

function status(value) {
  switch (value) {
    case "completed" :
      return "Completed";
    case "failed" :
      return "Failed";
    case "queued" :
      return "Queued";
    case "retained" :
      return "Sleeping";
    case "active" :
    case "running" :
      return "Running";
    case "starting" :
      return "Starting";
    case "stopped" :
      return "Stopped";
    default:
      return value;
  }
}

export {
  workspace,
  project,
  session,
  path,
  route,
  status,
}
/* No side effect */
